export const version = "hdnode/5.6.2";
//# sourceMappingURL=_version.js.map